import React from 'react';
import { useTranslation } from 'react-i18next';

export const UnitSelector = ({ unit, onUnitChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 bg-zinc-900 rounded-lg p-1 border border-orange-900/30">
      <button
        onClick={() => onUnitChange('m2')}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
          unit === 'm2'
            ? 'bg-gradient-to-r from-orange-600 to-orange-500 text-black shadow-md shadow-orange-600/50'
            : 'text-orange-600/70 hover:text-orange-500'
        }`}
      >
        m²
      </button>
      <button
        onClick={() => onUnitChange('sqft')}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
          unit === 'sqft'
            ? 'bg-gradient-to-r from-orange-600 to-orange-500 text-black shadow-md shadow-orange-600/50'
            : 'text-orange-600/70 hover:text-orange-500'
        }`}
      >
        sqft
      </button>
    </div>
  );
};
